import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import LocaleStrings from "Languages";

class PollReslutUserListItem extends Component {
  constructor(props) {
    super(props);
  }

  usersList = () => {
    var { option } = this.props;
    var mainStyle = {
      border: "1px solid #c5bfbf70",
      borderRadius: 10,
      padding: "5px 10px",
      marginBottom: 4,
    };
    var div1 = {};
    var div2 = {
      wordBreak: "break-all",
      width: "100%",
      fontSize: 11,
      color: "#4da1ff",
    };

    return _.map(option.usersList, (user, index) => {
      return (
        <div key={`key_${index}`} style={mainStyle}>
          <div> {user.username} </div>
          <div style={div2}> {user.email} </div>
        </div>
      );
    });
  };

  render() {
    let { option, totalOptions } = this.props;
    var className = "col-md-6";

    if (totalOptions == 3) {
      className = "col-md-4";
    } else if (totalOptions == 4) {
      className = "col-md-3";
    }
    var scrollStyle = {
      display: "inline-block",
      maxHeight: "100%",
      height: "auto",
      overflow: "auto",
      width: "100%",
    };

    return (
      <div className={className} style={{ padding: "2px 5px" }}>
        <h3 className="text-center">{option.option_text}</h3>

        <div className="text-center" style={{ fontSize: 11 }}>
          {option.usersList.length > 0
            ? LocaleStrings.polls_qa_text_poll_result_total_users +
              ": " +
              option.usersList.length
            : "-"}
        </div>

        <div className="h-divider">&nbsp;</div>
        <div className="clearfix">&nbsp;</div>
        <div style={scrollStyle}>{this.usersList()}</div>
      </div>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
  };
};
export default connect(mapStateToProps)(PollReslutUserListItem);
